module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};



//////////////////
// WEBPACK FOOTER
// /home/svc.teamcity.prd/BuildAgent/work/80562bb639a6ae70/node_modules/core-js/modules/_property-desc.js
// module id = piOq
// module chunks = 8